document.addEventListener('DOMContentLoaded', function() {

    const country = document.querySelector('#country');

    const init = function() {

        const buttons = country.querySelector('.js-buttons'),
              button = buttons.querySelectorAll('a'),
              map = country.querySelector('#maps'),
              area = map.querySelectorAll('.area');

        for (let i = 0; i < button.length; i++) {
            button[i].addEventListener('mouseover', (e) => {
                let id = e.currentTarget.dataset.id;
                maps.querySelector('[data-id="'+id+'"]').classList.add('is-active');
            })

            button[i].addEventListener('mouseout', (e) => {
                maps.querySelector('.is-active').classList.remove('is-active');
            })

            button[i].addEventListener('click', (e) => {
                if(button[i].href){
                    return;
                }
                const btn = button[i];

                btn.textContent = btn.dataset.msg;
                setTimeout(() => {
                    btn.textContent = btn.dataset.title;
                }, 1000);
            })
        }

        for (let i = 0; i < area.length; i++) {
            area[i].addEventListener('mouseover', (e) => {
                let id = e.currentTarget.dataset.id;
                buttons.querySelector('[data-id="'+id+'"]').classList.add('is-active');
            })

            area[i].addEventListener('mouseout', (e) => {
                buttons.querySelector('.is-active').classList.remove('is-active');
            })

            area[i].addEventListener('click', (e) => {
                let url = buttons.querySelector('.is-active').href;
                if(!url){
                    const btn = buttons.querySelector('.is-active');
                    btn.textContent = btn.dataset.msg;
                    setTimeout(() => {
                        btn.textContent = btn.dataset.title;
                    }, 1000);
                }
                window.open(url, '_self');
                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
            })
        }


    }

    country ? init() : false;

}, false);
